import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import { PedidoHistorico } from 'src/app/api';
import { LocalStorageService } from "./localstorage.service";

export interface AreaResponse {
  cep: string;
  veiculos: string[];
  diaAdicional: number;
  horaLimiteMesmoDia: string;
  horaLimiteColeta: string;
  dataColeta: string;
  dataPostagem: string;
  observacao?: string;
  observacaoCadastro?: string;
}

@Injectable()
export class OrderService {

  private URL: string = environment.angularJSconstants.URLAPIPEDIDO;

  constructor(private http: HttpClient, private localStorageService: LocalStorageService) {}

  validateArea(postalCode: number, ): Observable<AreaResponse> {
    return this.http.get<AreaResponse>(`${this.URL}/v2/areas/${postalCode}`);
  }

  getLatestOpenOrder(): Observable<PedidoHistorico> {
    const token = localStorage.getItem('ls.token');

    const headers = new HttpHeaders({
      Authorization: this.localStorageService.get("token"),
    });

    return this.http.get<PedidoHistorico>(`${this.URL}/v1/pedidos/ultimoAberto`, {headers});
  }

  podeBloquearEncomenda(encomendaId: number): Promise<any> {
    return this.http
      .get(
        `${this.URL}/v1/encomendas/${encomendaId}/pode-bloquear`,
        this.makeHeaders()
      ).toPromise();
  }

  bloquearEncomenda(encomendaId: number, motivo: object): Observable<any> {
    return this.http
      .post(
        `${this.URL}/v1/encomendas/${encomendaId}/bloquear`, motivo,
        this.makeHeaders()
      );
  }

  private makeHeaders() {
    const headers = new HttpHeaders({
      Authorization: this.localStorageService.get("token"),
    });

    return {
      headers,
      responseType: "text" as "json",
    };
  }
}
